<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');
  $primary-color: #70953a;
  body{
    background: url('https://edlservices.s3.eu-north-1.amazonaws.com/woodblocker/bg-tile.png');
  }

#app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .btn-primary{
    background-color:$primary-color;
    border-color:$primary-color
  }
}
</style>
